import { useEffect, useRef, useState } from 'react';

export const useElementHeight = (): [
  React.RefObject<HTMLDivElement>,
  number | null
] => {
  const [height, setHeight] = useState<number | null>(null);
  const ref = useRef(null);
  const hasObservedRef = useRef(false);

  useEffect(() => {
    const element = ref.current;
    if (element === null || hasObservedRef.current === true) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      if (!hasObservedRef.current) {
        const entry = entries[0];
        setHeight(entry?.contentRect.height ?? 0);
        hasObservedRef.current = true;
        resizeObserver.disconnect(); // Stop observing after first measurement
      }
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return [ref, height];
};
